import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { useQuery } from 'react-query';
import api from 'utils/api';
import isAdmin from 'utils/session/isAdmin';
import { getPageOffset } from 'utils/pagination';
import { announcementQueryKeys } from 'actions/announcements';
import getUserId from 'utils/session/getUserId';
export var ANNOUNCEMENTS_PER_PAGE = 100;
export var useFetchAnnouncements = function useFetchAnnouncements(_ref) {
  var _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? ANNOUNCEMENTS_PER_PAGE : _ref$limit,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? 1 : _ref$page,
    search = _ref.search,
    _ref$includeDraftsAnd = _ref.includeDraftsAndScheduled,
    includeDraftsAndScheduled = _ref$includeDraftsAnd === void 0 ? false : _ref$includeDraftsAnd,
    _ref$includeTotal = _ref.includeTotal,
    includeTotal = _ref$includeTotal === void 0 ? false : _ref$includeTotal;
  function fetchAnnouncements() {
    return _fetchAnnouncements.apply(this, arguments);
  }
  function _fetchAnnouncements() {
    _fetchAnnouncements = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var offset, formattedDate, listQuery, countQuery, queries, _yield$Promise$all, _yield$Promise$all2, announcements, count, items, total;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            offset = getPageOffset({
              page: page,
              itemsPerPage: limit
            });
            formattedDate = new Date().toISOString();
            listQuery = {
              fields: ['id', 'title', 'callOut', 'publishTime', {
                isRead: 'userAnnouncement.isRead',
                isDismissed: 'userAnnouncement.isDismissed'
              }],
              filter: {
                is_deleted: 0,
                publishTime: includeDraftsAndScheduled ? undefined : "..".concat(formattedDate),
                title: search ? "%".concat(search, "%") : undefined
              },
              // User announcements don't have entry until user reads or dismiss announcement
              // So we need to check for null user_id
              join: {
                userAnnouncement: {
                  user_id: [getUserId(), null]
                }
              },
              orderby: ['publishTime DESC', 'id DESC'],
              limit: limit,
              start: offset
            };
            countQuery = {
              fields: {
                count: 'COUNT(DISTINCT id)'
              },
              limit: 10000,
              notfound: 0
            };
            queries = [api('get', '/api/query/announcement', listQuery), includeTotal ? api('get', '/api/query/announcement', countQuery) : undefined];
            _context.next = 7;
            return Promise.all(queries);
          case 7:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            announcements = _yield$Promise$all2[0];
            count = _yield$Promise$all2[1];
            items = announcements.items;
            total = (count === null || count === void 0 ? void 0 : count.items[0].count) || 0;
            return _context.abrupt("return", {
              items: items.map(function (item) {
                // Cast `isRead` and `isDismissed` from `0` and `1` to `boolean`
                item.isRead = !!item.isRead;
                item.isDismissed = !!item.isDismissed;
                return item;
              }),
              total: total
            });
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchAnnouncements.apply(this, arguments);
  }
  var _useQuery = useQuery(announcementQueryKeys.announcementsList({
      limit: limit,
      page: page,
      search: search,
      includeDraftsAndScheduled: includeDraftsAndScheduled,
      includeTotal: includeTotal
    }), fetchAnnouncements, {
      enabled: isAdmin()
    }),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded);
  return _objectSpread({
    items: (data === null || data === void 0 ? void 0 : data.items) || [],
    total: data === null || data === void 0 ? void 0 : data.total
  }, result);
};
export default useFetchAnnouncements;